var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1924 4.39443L13.9005 1.95302C13.1385 1.51954 12.2063 1.51954 11.4443 1.95302L7.15238 4.39444L2.89969 6.90401C2.14388 7.35003 1.67419 8.1637 1.66717 9.04891L1.62796 14L1.66717 18.9511C1.67419 19.8363 2.14388 20.65 2.89969 21.096L7.15233 23.6055L11.4443 26.047C12.2063 26.4805 13.1385 26.4805 13.9005 26.047L18.1925 23.6056L22.4451 21.096C23.2009 20.65 23.6706 19.8363 23.6777 18.9511L23.7169 14L23.6777 9.04891C23.6706 8.1637 23.201 7.35003 22.4451 6.90401L18.1924 4.39443ZM19.0086 2.98585L14.7054 0.538029C13.4443 -0.179343 11.9005 -0.179343 10.6394 0.538029L6.33621 2.98585L2.07235 5.50202C0.822763 6.23942 0.0508412 7.58124 0.0393184 9.03601L0 14L0.0393184 18.964C0.0508412 20.4188 0.822764 21.7606 2.07235 22.498L6.33621 25.0142L10.6394 27.462C11.9005 28.1793 13.4443 28.1793 14.7054 27.462L19.0086 25.0142L23.2725 22.498C24.5221 21.7606 25.294 20.4188 25.3055 18.964L25.3448 14L25.3055 9.03601C25.294 7.58124 24.5221 6.23942 23.2725 5.50201L19.0086 2.98585Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.991 9.44187H7.48826V14.814C7.48826 17.8077 9.86596 20.1861 12.7396 20.1861C15.6133 20.1861 17.991 17.8077 17.991 14.814V9.44187ZM19.619 7.81396V14.814C19.6189 18.6799 16.539 21.814 12.7396 21.814C8.9403 21.814 5.86036 18.6799 5.86035 14.814V7.81396H19.619Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79297 7.72412C5.79297 8.28458 5.8577 8.82966 5.97997 9.35203C6.70111 12.4329 9.42374 14.7241 12.6723 14.7241C15.9208 14.7241 18.6434 12.4329 19.3646 9.35203C19.4869 8.82966 19.5516 8.28458 19.5516 7.72412H5.79297ZM7.66554 9.35203C8.34245 11.5359 10.3447 13.0962 12.6723 13.0962C14.9999 13.0962 17.0021 11.5359 17.679 9.35203H7.66554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9858ab8e8556753d67be9716d801ef92.svg";
export { ForwardRef as ReactComponent };